import {ErrorHandler, Injectable} from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import {NzNotificationService} from 'ng-zorro-antd/notification';

@Injectable()
export class AppErrorHandler implements ErrorHandler {

  /**
   * Prevents error-handling cascades: if an error is raised while we are
   * already handling one (e.g. a toSignal/resource whose stream errored keeps
   * re-throwing on every change-detection pass), suppress the follow-up
   * instead of spawning notification after notification until the tab dies.
   */
  private handlingError = false;

  constructor(private notifier: NzNotificationService) {
  }

  handleError(rawError: any): void {
    if (this.handlingError) {
      return;
    }
    this.handlingError = true;
    try {
      let message: string;
      let title: string;
      const error = rawError?.hasOwnProperty('rejection') ? rawError.rejection : rawError;
      if (error?.graphQLErrors) {
        title = 'GraphQL Error';
        message = error.message;
      } else if (error instanceof Error) {
        title = 'Unexpected Error';
        message = error.message;
      } else if (error instanceof HttpErrorResponse) {
        if (!!error.error && typeof (error.error) === 'object') {
          title = error.error.title;
          message = error.error.error ?? error.error.detail;
        } else {
          title = error.statusText;
          message = error.error;
        }
      } else {
        title = 'Unexpected Error';
        message = String(error);
      }
      // keep the notification payload small and text-safe; a huge or
      // HTML-laden error body can choke the sanitizer/notification rendering
      this.notifier.error(String(title ?? 'Error'), String(message ?? 'Unknown error').slice(0, 500), {nzDuration: 30000});
    } finally {
      this.handlingError = false;
    }
    // intentionally NOT re-throwing: rethrowing from handleError re-enters the
    // zone error pipeline and can turn a single failure into an endless loop
  }

}
